import { render, staticRenderFns } from "./CorporateAnnouncementStockRow.vue?vue&type=template&id=22254e3e&scoped=true"
import script from "./CorporateAnnouncementStockRow.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementStockRow.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementStockRow.vue?vue&type=style&index=0&id=22254e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22254e3e",
  null
  
)

export default component.exports